<template>
    <section class="effortless">
        <div class="container">
            <h2>Saving made so simple, it is effortless</h2>
            <div class="icon-row">
                <div class="row">
                    <div class="col-md-4">
                        <div class="icon-box">
                            <img src="../../assets/img/features/two-man.png" alt="">
                            <h3 class="icon-title">Partner up or go solo</h3>
                            <p>PlusMinus is designed for however you live your life. We are the first group banking solution for
                                everyone.</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="icon-box">
                            <img src="../../assets/img/features/save.png" alt="">
                            <h3>Set goals and plans</h3>
                            <p>Money is personal, so PlusMinus is too. What are your goals? We’ll help you personlize your
                                savings, spending and investing goals.</p>
                        </div>  
                    </div>
                    <div class="col-md-4">
                        <div class="icon-box">
                            <img src="../../assets/img/features/automate.png" alt="">
                            <h3>Automate and save</h3>
                            <p>PlusMinus will do the hard work for you. Fund your goals first, cover your costs, spend the rest
                                guilt-free.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import ChartCircleTwo from '../ChartCircleTwo'
    import NewsletterTwo from '../NewsletterTwo'
    export default{
        name: 'AppShowcaseNewsletter',
        components: {
            NewsletterTwo,
            ChartCircleTwo
        }
    };
</script>

<style>
.main-text{
    text-align: center;
    padding-top:5%;
    font-family: Nunito Sans;
    font-style: normal;
    font-weight: 800;
    font-size: 48px;
    color:#214F4D;
}
</style>